export const WEB_FONTS_PROVIDERS = {
  GOOGLE: 'google',
  CUSTOM: 'custom',
};
